import COLIAN_DEVELOPER_LOGO from '../static/developer/colian-developer/logo-goplana-osiedle-color.jpg'
import COLIAN_DEVELOPER_FLOORPLAN1 from '../static/developer/colian-developer/rzuty/E_46.png'
import COLIAN_DEVELOPER_FLOORPLAN2 from '../static/developer/colian-developer/rzuty/E_61.png'
import COLIAN_DEVELOPER_FLOORPLAN3 from '../static/developer/colian-developer/rzuty/E_80.png'

import REMAX_LOGO from '../static/developer/remax/2019-01-Remax-EXPERTS-balon-PNG.png'
import REMAX_FLOORPLAN1 from '../static/developer/remax/rzuty/dabrowskiego.png'
import REMAX_FLOORPLAN2 from '../static/developer/remax/rzuty/jagielly17.png'
import REMAX_FLOORPLAN3 from '../static/developer/remax/rzuty/wichrowewzgorze.png'

import KONIMPEX_LOGO from '../static/developer/konimpex-invest/konimpex_logo.jpg'
import KONIMPEX_FLOORPLAN1 from '../static/developer/konimpex-invest/rzuty/A_29.png'
import KONIMPEX_FLOORPLAN2 from '../static/developer/konimpex-invest/rzuty/A_32.png'
import KONIMPEX_FLOORPLAN3 from '../static/developer/konimpex-invest/rzuty/A_48.png'

import EVEREST_DEVELOPER_LOGO from '../static/developer/everest-development/logo.png'
import EVEREST_DEVELOPER_FLOORPLAN1 from '../static/developer/everest-development/rzuty/M12.png'
import EVEREST_DEVELOPER_FLOORPLAN2 from '../static/developer/everest-development/rzuty/M18.png'
import EVEREST_DEVELOPER_FLOORPLAN3 from '../static/developer/everest-development/rzuty/D05.png'

import KWIATOWE_TARASY_LOGO from '../static/developer/kwiatowe-tarasy/logo.png'
import KWIATOWE_TARASY_FLOORPLAN1 from '../static/developer/kwiatowe-tarasy/rzuty/A1_M2.png'
import KWIATOWE_TARASY_FLOORPLAN2 from '../static/developer/kwiatowe-tarasy/rzuty/B3_M1.png'

import BTM_LOGO from '../static/developer/btm/logo.jpg'
import BTM_FLOORPLAN1 from '../static/developer/btm/rzuty/7.png'
import BTM_FLOORPLAN2 from '../static/developer/btm/rzuty/8.png'
import BTM_FLOORPLAN3 from '../static/developer/btm/rzuty/9.png'

import PREMIUM_PROPERTIES_LOGO from '../static/developer/premium-properties/osiedle-kwiat-logo.png'
import PREMIUM_PROPERTIES_FLOORPLAN1 from '../static/developer/premium-properties/rzuty/a29.png'
import PREMIUM_PROPERTIES_FLOORPLAN2 from '../static/developer/premium-properties/rzuty/a8.png'
import PREMIUM_PROPERTIES_FLOORPLAN3 from '../static/developer/premium-properties/rzuty/c90.png'

import AKROPOL_LOGO from '../static/developer/akropol-inwestycje/logo-retina.png'
import AKROPOL_FLOORPLAN1 from '../static/developer/akropol-inwestycje/rzuty/M3.png'
import AKROPOL_FLOORPLAN2 from '../static/developer/akropol-inwestycje/rzuty/M-0_03.png'
import AKROPOL_FLOORPLAN3 from '../static/developer/akropol-inwestycje/rzuty/M-1_04.png'

import SSS_INVEST_LOGO from '../static/developer/sss-invest/logo.png'
import SSS_INVEST_FLOORPLAN1 from '../static/developer/sss-invest/rzuty/E-P-5.png'
import SSS_INVEST_FLOORPLAN2 from '../static/developer/sss-invest/rzuty/A7.png'
import SSS_INVEST_FLOORPLAN3 from '../static/developer/sss-invest/rzuty/A8.png'

import PASSA_LOGO from '../static/developer/passa/Passa-Deweloper-logo.png'
import PASSA_FLOORPLAN1 from '../static/developer/passa/rzuty/A1.png'

import RENOMA_LOGO from '../static/developer/renoma/e4c2f42e.jpeg'
import RENOMA_FLOORPLAN1 from '../static/developer/renoma/rzuty/Gwiazdzista-1.png'
import RENOMA_FLOORPLAN2 from '../static/developer/renoma/rzuty/Uradzka-1.png'

import JAGODOWE_LOVE_LOGO from '../static/developer/jagodowe-love/jagodowe-love.png'
import JAGODOWE_LOVE_FLOORPLAN1 from '../static/developer/jagodowe-love/rzuty/10A.png'
import JAGODOWE_LOVE_FLOORPLAN2 from '../static/developer/jagodowe-love/rzuty/10B.png'
import JAGODOWE_LOVE_FLOORPLAN3 from '../static/developer/jagodowe-love/rzuty/1A.png'

import SPOMET_LOGO from '../static/developer/spomet/Bez-nazwy-2.jpg'
import SPOMET_FLOORPLAN1 from '../static/developer/spomet/rzuty/dom-jednorodzinny.png'

import GEP_LOGO from '../static/developer/gephouse/gephouse.png'
import GEP_FLOORPLAN1 from '../static/developer/gephouse/rzuty/nowy-dopiewiec_1.png'
import GEP_FLOORPLAN2 from '../static/developer/gephouse/rzuty/radzyny_1.png'

import DATAHOUSE_LOGO from '../static/developer/datahouse/logo.png'
import DATAHOUSE_FLOORPLAN1 from '../static/developer/datahouse/rzuty/1.png'
import DATAHOUSE_FLOORPLAN2 from '../static/developer/datahouse/rzuty/2.png'

import ROS_LOGO from '../static/developer/rospain/logo.png'
import ROS_FLOORPLAN1 from '../static/developer/rospain/rzuty/amara.png'
import ROS_FLOORPLAN2 from '../static/developer/rospain/rzuty/vivienda.png'

import SCANDIC_LOGO from '../static/developer/scandic-park/logo.png'
import SCANDIC_LOGO2 from '../static/developer/scandic-park/logo2.png'
import SCANDIC_FLOORPLAN1 from '../static/developer/scandic-park/rzuty_Bajka/1.png'
import SCANDIC_FLOORPLAN2 from '../static/developer/scandic-park/rzuty_Nove/2.png'
import SCANDIC_FLOORPLAN3 from '../static/developer/scandic-park/rzuty_Nove/5.png'

export const ClientsData = [
  {
    id: 1,
    title: 'DATHOUSE',
    description: 'Przedstawiamy ofertę sprzedazy domu w Poznaniu, dzielnica Morasko, raptem 1000 m od pętli tramwajowej PST. \n',
    logoUrl: DATAHOUSE_LOGO,
    clientUrl: 'https://dathouse.pl/Szklarniowa-Morasko/',
    apartmentData: [
      {
        streetName: 'Osiedle na Wzgórzu',
        number: '1',
        sqm: '146 ',
        floorPlanUrl: DATAHOUSE_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/osiedle-na-wzgorzu/1.3d',
      },
      {
        streetName: 'Osiedle na Wzgórzu',
        number: '2',
        sqm: '146 ',
        floorPlanUrl: DATAHOUSE_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/osiedle-na-wzgorzu/2.3d',
      },
    ]
  },
  {
    id: 2,
    title: 'Scandic Park',
    description: `Nove Dopiewo to kameralny kompleks 20 mieszkań realizowany w malowniczej enklawie koło Poznania, która cieszy się niesłabnącą aprobatą mieszkańców.
    Projekt powstał z myślą o ludziach poszukujących komfortowych i funkcjonalnych mieszkań w zacisznym miejscu. Na terenie kompleksu przewidziany został parking dla mieszkańców oraz ich gości. Do każdego lokalu mieszkalnego - miejsce parkingowe w cenie.
    W nowoczesnym 3 kondygnacyjnym budynku proponujemy lokale 1- oraz 2-pokojowe o powierzchni od 30 do 64 m2. Lokale zlokalizowane na parterze będą posiadały ogrody o powierzchniach od 41,2 m2 do 110 m2, natomiast lokale na piętrze funkcjonalne balkony.
    Do dyspozycji mieszkańców zostanie również oddana wspólna, zazieleniona część rekreacyjna. Ceny mieszkań zaczynają się od 225 792zł, a budowa zostanie zakończona 30.05.2023r. Szczegóły dotyczące inwestycji mogą Państwo uzyskać na stoisku H7. Serdecznie zapraszamy! \n`,
    logoUrl: SCANDIC_LOGO,
    clientUrl: 'https://scandic-park.pl/nove-dopiewo/',
    apartmentData: [
      {
        streetName: 'Nove Dopiewo',
        number: '2',
        sqm: '65 ',
        floorPlanUrl: SCANDIC_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/nove-dopiewo/2.3d',
      },
      {
        streetName: 'Nove Dopiewo',
        number: '5',
        sqm: '43 ',
        floorPlanUrl: SCANDIC_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/nove-dopiewo/5.3d',
      },
    ]
  },
  {
    id: 3,
    title: 'Scandic Park',
    description: `Osiedle Bajkowy Dopiewiec to unikatowy koncept składający się z 20 parterowych EcoVilli w zabudowie bliźniaczej o powierzchniach 77 m2 oraz 89 m2. Każdy dom parterowy to przestronny salon z aneksem kuchennym, 3 sypialnie, łazienka oraz pomieszczenie gospodarcze. Do każdej nieruchomości przypisane są również dwa miejsca postojowe.
    Inwestycję charakteryzuje niewielkie zagęszczenie zabudowy ponadczasowy, skandynawski design, praktyczny układ pomieszczeń oraz zaawansowane rozwiązania w zakresie energooszczędności.
    Bazujemy na najwyższej jakości materiałach oraz unikatowych rozwiązaniach energooszczędnych. W cenie domu oferowana jest kompletna instalacja fotowoltaiczna, która zapewni stałe, niskie koszty ogrzewania, prądu a także ciepłą wodę. Ponadto, stawiając na czystą energię  przyczyniamy się do ograniczenia emisji CO2, likwidacji smogu oraz dbałości o równowagę środowiskową. 
    Ceny domów wynoszą od 5 600zł brutto/mkw, a budowa zostanie zakończona już w listopadzie 2022r.
    Szczegóły dotyczące inwestycji mogą Państwo uzyskać na stoisku H7. Serdecznie zapraszamy!  \n`,
    logoUrl: SCANDIC_LOGO2,
    clientUrl: 'https://www.bajkowydopiewiec.pl/',
    apartmentData: [
      {
        streetName: 'Bajkowy Dopiewiec',
        number: '1',
        sqm: '89,33 ',
        floorPlanUrl: SCANDIC_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/bajkowy-dopiewiec/1.3d',
      },
    ]
  },
  {
    id: 4,
    title: 'RO Spain Real Estate',
    description: `RO SPAIN Real Estate to sprawdzony pośrednik w zakupie nieruchomości w Hiszpanii
    świadczący obsługę również w języku polskim.
    Od 2005 roku świadczy profesjonalne usługi na rynku nieruchomości w Hiszpanii,
    Holandii, Belgii, Wielkiej Brytanii i w Polsce.
    Posiada największy wybór ofert z rynku pierwotnego i wtórnego, a także projektuje wille
    na zamówienie z widokiem na morze w 1 linii brzegowej.
    Specjalizuje się w budowie, wynajmie i sprzedaży nieruchomości na wybrzeżu Costa
    Blanca i Costa Cálida. Współpracuje bezpośrednio ze stronami sprzedającymi, dzięki
    czemu gwarantuje swoim klientom niższą cenę. \n`,
    logoUrl: ROS_LOGO,
    clientUrl: 'https://www.ro-spain.com/',
    apartmentData: [
      {
        streetName: 'Amara',
        number: 'Amara',
        sqm: '173,96 ',
        floorPlanUrl: ROS_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/ro-spain-real-estate/amara.3d',
      },
      {
        streetName: 'Vivienda',
        number: 'Vivienda',
        sqm: '275,47 ',
        floorPlanUrl: ROS_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/ro-spain-real-estate/vivienda.3d',
      },
    ]
  },
  {
    id: 5,
    title: 'Konimpex Invest',
    description: 'Inwestycja Świętego Michała będzie się znajdowała przy ul. Świętego Michała 30, 32 w Poznaniu. Budynek będzie się składał z dwóch części: wysokiej o 11 kondygnacjach i niskiej o budowie kaskadowej, do 6 kondygnacji. W inwestycji zaprojektowano 88 mieszkań o powierzchniach od 36 m2 do 135 m2. Mieszkania znajdujące się na ostatnich kondygnacjach będą z tarasami. \n' +
      'Na dachu zostaną zamontowane panele fotowoltaiczne, które będą bilansowały koszty oświetlenia części wspólnych budynku. <br /> <br />' +
      'Dużym atutem jest  świetna lokalizacja! Komunikacja miejska w odległości ok. 350 m (przystanek tramwajowy przy ul. Warszawskiej oraz pętla tramwajowa na Zawadach). Szybki dojazd do dróg dojazdowych, w tym autostrady A2. W niedalekim sąsiedztwie znajdują się tereny dla miłośników aktywności fizycznej: Jezioro Malta czy Park 1000-lecia, Termy Maltańskie, a dla najmłodszych Nowe ZOO. W okolicy znajduje się wiele kultowych restauracji i kawiarni, np. na poznańskiej Śródce. Więcej na swietegomichala.pl',
    logoUrl: KONIMPEX_LOGO,
    clientUrl: 'https://swietegomichala.pl/pl/start',
    apartmentData: [
      {
        streetName: 'Świętego Michała',
        number: 'A_29',
        sqm: '52,84 ',
        floorPlanUrl: KONIMPEX_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/swietego-michala/a_29.3d',
      },
      {
        streetName: 'Świętego Michała',
        number: 'A_32',
        sqm: '74,70 ',
        floorPlanUrl: KONIMPEX_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/swietego-michala/a_32.3d',
      },
      {
        streetName: 'Świętego Michała',
        number: 'A_48',
        sqm: '135,27 ',
        floorPlanUrl: KONIMPEX_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/swietego-michala/a_48.3d',
      },
    ]
  },
  {
    id: 6,
    title: 'Everest Development',
    description: 'Sianożęty\n' +
      'Nowoczesne apartamenty w Ustroniu Morskim idealne do użytku własnego i wynajmu.\n' +
      '3 budynki, 90 lokali, 270 mieszkań dwu i trzypokojowych o powierzchniach w przedziale od 33,87 m2 do 69,35 m2. Inwestycja dysponuje 41 miejscami parkingowymi na parkingu podziemnym oraz 201 na terenie osiedla. Każdy apartament posiada ogród(parter) lub balkon. Dach budynku został podzielony na duże tarasy, które również przeznaczone są do sprzedaży. Wszystko w nowoczesnej oraz spójnej estetyce. Wysoka trwałość gwarantuje funkcjonalność i użyteczność wnętrz na długie lata.\n' +
      'Dostępna jest również możliwość wykończenia mieszkania zgodnie ze standardem.\n' + '<br/><br/>' +
      'Mateckiego 20\n' +
      'To kolejny, drugi etap inwestycji na osiedlu Mateckiego20. Zakończenie budowy i oddanie mieszkań planowane jest na I kwartał 2023 roku. Inwestycja obejmuje 117 przestronnych i komfortowych mieszkań o powierzchni od 37,18 do 65,04m2. Możliwe do nabycia również komórki lokatorskie i miejsca parkingowe. Do mieszkań znajdujących się na parterze przypisane są ogródki. Na wyższych piętrach znajdują się mieszkania posiadające balkony. Mieszkania są jasne i pełne słońca. Mieszkania są ustawne – łatwo zagospodarować przestrzeń w użyteczny sposób. Osiedle to wyróżnia bliskość wielu terenów zielonych, z dala od miejskiego zgiełku – idealne dla osób ceniących sobie ciszę i spokój.\n',
    logoUrl: EVEREST_DEVELOPER_LOGO,
    clientUrl: 'https://everest-development.pl/inwestycja/sprzedaz-mieszkan-w-ustroniu-morskim-2/',
    p2: true,
    apartmentData: [
      {
        streetName: 'Sianożęty',
        number: 'M12',
        sqm: '70,59 ',
        floorPlanUrl: EVEREST_DEVELOPER_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/sianozety/m12.3d',
      },
      {
        streetName: 'Sianożęty',
        number: 'M18',
        sqm: '67,66 ',
        floorPlanUrl: EVEREST_DEVELOPER_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/sianozety/m18.3d',
      },
      {
        streetName: 'Mateckiego 20',
        number: 'D05',
        sqm: '61,35 ',
        floorPlanUrl: EVEREST_DEVELOPER_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/mateckiego-20/d05.3d',
      },
    ]
  },
  {
    id: 7,
    title: 'Colian Developer',
    description: '"Osiedle Goplana to kilkuetapowy projekt stworzenia nowoczesnej miejskiej struktury z funkcją mieszkaniową, rozmaitymi usługami, gdzie współczesna architektura nawiązuje do industrialnych tradycji i historii lokalizacji. Na osiedlu w niedalekiej przyszłości powstaną place, zielone skwery i deptaki. Zaledwie kilka kroków dzieli osiedle od Sołacza - najpiękniejszej dzielnicy i parku Poznania. \n' +
      'Nowy etap inwestycji to 8 piętrowy budynek, z reprezentacyjną ekspozycją od strony ulicy Św. Wawrzyńca. Na elewacji budynku zostaną zastosowane wysokiej jakości materiały ceramiczne, elementy metalowe i tynki dekoracyjne. Górne kondygnacje będą miały unikalny widok na panoramę Sołacza. Od strony wschodniej budynek sąsiaduje z planowanym Placem Czekoladowym, który będzie stanowił centralny punkt osiedla." \n',
    logoUrl: COLIAN_DEVELOPER_LOGO,
    clientUrl: 'https://osiedlegoplana.pl/pl/inwestycja',
    apartmentData: [
      {
        streetName: 'Osiedle Goplana',
        number: 'E_46',
        sqm: '139,49 ',
        floorPlanUrl: COLIAN_DEVELOPER_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/osiedle-goplana/e_46.3d',
      },
      {
        streetName: 'Osiedle Goplana',
        number: 'E_61',
        sqm: '50,20 ',
        floorPlanUrl: COLIAN_DEVELOPER_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/osiedle-goplana/e_61.3d',
      },
      {
        streetName: 'Osiedle Goplana',
        number: 'E_80',
        sqm: '75,67 ',
        floorPlanUrl: COLIAN_DEVELOPER_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/osiedle-goplana/e_80.3d',
      },
    ]
  },
  {
    id: 8,
    title: 'Re/MAX',
    description: 'Poznańskie biuro RE/MAX Experts oferuje fachowe i kompleksowe usługi pośrednictwa w sprzedaży, zakupie i wynajmie różnego typu nieruchomości. Działamy głównie w Wielkopolsce, ale dzięki współpracy z innymi biurami naszej międzynarodowej agencji możemy obsłużyć klientów, którzy posiadają lub szukają nieruchomości w całej Polsce, Europie i wielu innych krajach świata. Oferta RE/MAX Experts obejmuje domy, mieszkania, działki oraz lokale i obiekty komercyjne. Nasze know-how i kompetencje agentów gwarantują najwyższą skuteczność, wiarygodność i bezpieczeństwo. Odnosimy duże sukcesy!  \n',
    logoUrl: REMAX_LOGO,
    clientUrl: '',
    p2: true,
    apartmentData: [
      {
        streetName: 'Dąbrowskiego',
        number: '7',
        sqm: '95,9 ',
        floorPlanUrl: REMAX_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/remax/dabrowskiego.3d',
      },
      {
        streetName: 'Jagiełły17',
        number: '15',
        sqm: '64,9 ',
        floorPlanUrl: REMAX_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/remax/jagielly17.3d',
      },
      {
        streetName: 'Wichrowe Wzgórze',
        number: 'M6',
        sqm: '64,9 ',
        floorPlanUrl: REMAX_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/remax/wichrowewzgorze.3d',
      },
    ]
  },
  {
    id: 9,
    title: 'Brego Development',
    description: 'Kwiatowe Tarasy to osiedle domów jednorodzinnych, stworzone dla miłośników kameralnego stylu życia. Nowoczesna zabudowa, wysoki standard wykończenia i przyjazna okolica sprawiają, że jest to wymarzone miejsce do życia. Sama lokalizacja znajduje się w miejscowości Sady k. Poznania przy ul. Lotosowej. Dowiedz się więcej i wejdź na stronę www.kwiatowetarasy.pl\n',
    logoUrl: KWIATOWE_TARASY_LOGO,
    clientUrl: 'https://kwiatowetarasy.pl',
    p2: true,
    apartmentData: [
      {
        streetName: 'Kwiatowe Tarasy',
        number: 'A1_M2',
        sqm: '135,9 ',
        floorPlanUrl: KWIATOWE_TARASY_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/kwiatowe-tarasy/a1_m2.3d',
      },
      {
        streetName: 'Kwiatowe Tarasy',
        number: 'B3_M1',
        sqm: '175,85 ',
        floorPlanUrl: KWIATOWE_TARASY_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/kwiatowe-tarasy/b3_m1.3d',
      },
    ]
  },
  {
    id: 10,
    title: 'BTM',
    description: 'Osiedle Parkowa w Biedrusku to 102 mieszkania: 44 w pierwszym, 30 w drugim i 38 w trzecim etapie budowy. Oferujemy Państwu duży wybór mieszkań o zróżnicowanych powierzchniach i układach funkcjonalnych o powierzchniach od 31m2 do 74 m2. Dla każdego lokalu mieszkalnego przewidzieliśmy dwa miejsca postojowe w hali garażowej, a dbając o Państwa wygodę wyposażaliśmy każdą klatkę schodową w windę. Na terenie inwestycji zaplanowaliśmy plac zabaw dla dzieci, dostępny dla wszystkich mieszkańców. Ponadto w najbliższej okolicy znajdują się tereny zielone, boiska sportowe oraz ścieżki spacerowe i rowerowe.\n',
    logoUrl: BTM_LOGO,
    clientUrl: '',
    p2: true,
    apartmentData: [
      {
        streetName: 'Parkowa 6',
        number: '7',
        sqm: '61,00 ',
        floorPlanUrl: BTM_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/parkowa-6/7.3d',
      },
      {
        streetName: 'Parkowa 6',
        number: '8',
        sqm: '74,00 ',
        floorPlanUrl: BTM_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/parkowa-6/8.3d',
      },
      {
        streetName: 'Parkowa 6',
        number: '9',
        sqm: '56,30 ',
        floorPlanUrl: BTM_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/parkowa-6/9.3d',
      },
    ]
  },
  {
    id: 11,
    title: 'Premium Properties 5',
    description: 'Osiedle Witaj to wyjątkowy kompleks mieszkaniowy zlokalizowany z dala od zgiełku miasta, w zielonej części dzielnicy Naramowice w Poznaniu. Całość stanowić będzie nowoczesna zabudowa wraz ze starannie zaprojektowaną strefą rekreacyjno-wypoczynkową.Osiedle Witaj w swojej ofercie posiada 110 mieszkań dwu- trzy – oraz czteropokojowych o metrażach od 37 do 87 m².\n' +
      'Dodatkową przestrzeń lokali na wyższych kondygnacjach stanowić będą przestronne balkony, a dla lokali na parterze ogródki oddzielone żywopłotem od części wspólnych. Wygodne parkowanie umożliwią miejsca postojowe naziemne.\n',
    logoUrl: PREMIUM_PROPERTIES_LOGO,
    clientUrl: '',
    p2: true,
    apartmentData: [
      {
        streetName: 'Osiedle Witaj',
        number: 'A29',
        sqm: '64,59 ',
        floorPlanUrl: PREMIUM_PROPERTIES_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/osiedle-witaj/a29.3d',
      },
      {
        streetName: 'Osiedle Witaj',
        number: 'A8',
        sqm: '37,18 ',
        floorPlanUrl: PREMIUM_PROPERTIES_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/osiedle-witaj/a8.3d',
      },
      {
        streetName: 'Osiedle Witaj',
        number: 'C90',
        sqm: '75,91 ',
        floorPlanUrl: PREMIUM_PROPERTIES_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/osiedle-witaj/c90.3d',
      },
    ]
  },
  {
    id: 12,
    title: 'Akrpolo Inwestycje',
    description: 'Grupa Akropol Inwestycje jest w trakcie realizacji ponad 1000 domów i mieszkań zlokalizowanych w Poznaniu i jego najbliższej okolicy. Już wkrótce czekają na Państwa nowe mieszkania w Poznaniu ulokowane w inwestycjach Poznań Jasielska, Poznań Chlebowa oraz nowe domy Poznań Bobrownicka. Poznaj nasze nowe mieszkania na sprzedaż i wybierz z bogatej oferty odpowiednie właśnie dla Ciebie.\n' +
      'Dla osób ceniących spokój przedmieścia proponujemy inwestycje w Luboniu, np nowe mieszkania w stanie deweloperskim Luboń Na Skarpie oraz domy na sprzedaż Luboń Kościuszki czy Luboń Nowiny.\n' +
      'Szukając mieszkania w Poznaniu weź pod uwagę bardzo dobrze skomunikowane z Poznaniem mieszkania w Komornikach, Wirach oraz od strony wschodniej Poznania w miejscowości Rabowice. Nowe domy Komorniki Żabikowska, Komorniki Łąkowa, Wiry Poznańska czy Rabowice Olszynowa to doskonały wybór.\n' +
      'Wszyscy, którzy cenią sobie bliskość Poznania, jednocześnie szukają atrakcyjnej, zielonej okolicy zapraszamy do poznania inwestycji w Koninku, Biedrusku i Glinnie. Budujemy dla Państwa nowe domy oraz mieszkania w Koninku, w Biedrusku Osiedle Jesionowe oraz w Glinnie nowe mieszkania w stanie deweloperskim na Osiedlu Klonowym.\n' +
      '\n',
    logoUrl: AKROPOL_LOGO,
    clientUrl: 'https://akropol-inwestycje.pl/',
    p2: true,
    apartmentData: [
      {
        streetName: 'Zakrzewo',
        number: 'M3',
        sqm: '75,65 ',
        floorPlanUrl: AKROPOL_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/zakrzewo/m3.3d',
      },
      {
        streetName: '5 stycznia',
        number: 'M-0_03',
        sqm: '107,78 ',
        floorPlanUrl: AKROPOL_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/5-stycznia/m-0_03.3d',
      },
      {
        streetName: '5 stycznia',
        number: 'M-1_04',
        sqm: '51,12 ',
        floorPlanUrl: AKROPOL_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/5-stycznia/m-1_04.3d',
      },
    ]
  },
  {
    id: 13,
    title: 'SSS Invest',
    description: 'Nova Dachowa to kompleks 25 bliźniaczych budynków, których budowa jest podzielona na VI etapów.\n' +
      'Aktualnie w ramach I Etapu Inwestycji powstaje 8 domów w zabudowie bliźniaczej – łącznie z 16 lokalami mieszkalnymi o powierzchni 83m², z 2 miejscami postojowymi oraz ogrodem o powierzchni od 50m² do 80m². Dachowa to miejsce, które daje poczucie wytchnienia od zgiełku miasta i kojącą bliskość natury. Nowoczesna architektura i mnóstwo udogodnień pozwala cieszyć się miejskim komfortem: wysokie wnętrza, energooszczędne rozwiązania, własny ogródek, miejsca postojowe i kameralna, zielona okolica.\n' +
      'Wschodnia 19 to nowoczesna architektura w połączeniu  z funkcjonalnością. Doskonała lokalizacja w Luboniu pod Poznaniem - poza miastem, wśród zieleni, ale z pełną infrastrukturą. 146 mieszkań, o powierzchni od 38 do 83 m². Parter z ogródkiem od 10 do 77 m² lub mieszkanie z dużym tarasem –pełen pakiet możliwości. Ponadto lokale użytkowe na parterze. Niedalekie sąsiedztwo autostrady pozwala sprawnie podróżować, a bogata oferta usługowo-handlowa i rozbudowana infrastruktura rekreacyjno-sportowa zaspokoją wszystkie potrzeby bez konieczności oddalania od mieszkania.',
    logoUrl: SSS_INVEST_LOGO,
    clientUrl: '',
    p2: true,
    apartmentData: [
      {
        streetName: 'Wschodnia 19',
        number: 'E-P-5',
        sqm: '55,96 ',
        floorPlanUrl: SSS_INVEST_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/wschodnia-19/e-p-5.3d',
      },
      {
        streetName: 'Nova Dachowa',
        number: 'A7',
        sqm: '83,29 ',
        floorPlanUrl: SSS_INVEST_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/nova-dachowa/a7.3d',
      },
      {
        streetName: 'Nova Dachowa',
        number: 'A8',
        sqm: '83,13 ',
        floorPlanUrl: SSS_INVEST_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/nova-dachowa/a8.3d',
      },
    ]
  },
  {
    id: 14,
    title: 'Passa Deweloper',
    description: 'Posiadamy wieloletnie doświadczenie i wiedzę. Inwestycje realizujemy pod nadzorem inżynierów z grupy Inspektorzy 3miasto, którzy kompleksowo zarządzają całym procesem inwestycyjnym. Podpisując z nami umowę, masz pewność, że klucze do mieszkania otrzymasz terminowo. Specjalizujemy się w zabudowie jednorodzinnej i bliźniaczej. Realizowane przez nas inwestycje łączą wspólne cechy: jakość i odpowiedzialność. Budujemy zgodnie z najwyższymi standardami wykończenia, mając na uwadze zadowolenie, bezpieczeństwo i komfort przyszłych mieszkańców.',
    logoUrl: PASSA_LOGO,
    clientUrl: '',
    apartmentData: [
      {
        streetName: 'Passa Forest',
        number: 'A1',
        sqm: 'b.d. ',
        floorPlanUrl: PASSA_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/passa-forest/a1.3d',
      },
    ]
  },
  {
    id: 15,
    title: 'Renoma Inwestycje',
    description: 'Fundamentem powstania spółki deweloperskiej jest wieloletnie doświadczenie zdobyte przy realizacji projektów mieszkaniowych w fazie projektowania jak i realizacji. To doświadczenie uczuliło nas na szczególne zwracanie uwagi na aspekty, które zostały wymienione poniżej <br/><br/> Wspólnikami spółki są osoby po ukończonych studiach budowlanych wraz z odpowiednimi uprawnieniami budowlanymi, które sprawują bezpośredni nadzór nad wszystkimi realizacjami. Dzięki temu nasi klienci mogą być pewni, że zainwestowane przez nich pieniądze są w dobrych rękach. <br/><br/> Nasze inwestycje budujemy z sprawdzonych materiałów, które posiadają odpowiednie aprobaty techniczne, atesty, deklaracje jakości oraz są dopuszczone do stosowania w budownictwie. <br/><br/> Nasz zespół czuwa aby wnętrze spełniało oczekiwania przyszłych mieszkańców oraz było przede wszystkim funkcjonalne i ergonomiczne.',
    logoUrl: RENOMA_LOGO,
    clientUrl: '',
    p2: true,
    apartmentData: [
      {
        streetName: 'Gwiaździsta',
        number: '1',
        sqm: 'b.d. ',
        floorPlanUrl: RENOMA_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/passa-forest/a1.3d',
      },
      {
        streetName: 'Uradzka',
        number: '1',
        sqm: '82,38 ',
        floorPlanUrl: RENOMA_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/uradzka/1.3d',
      },
    ]
  },
  {
    id: 16,
    title: 'Jagodowe Love',
    description: 'Firma BOB Biełuś Sp. z o.o. od blisko 10 lat łącząc wiedzę, wieloletnie doświadczenie w branży, oraz nowoczesne technologie spełnia marzenia naszych klientów o własnym domu.\n' +
      'Każdą inwestycję traktujemy w indywidualny sposób, dbając o to by realizowane osiedla były dopełnieniem architektury miejsca, w którym są lokalizowane.\n' +
      'Projekty domów i osiedli, które budujemy cechuje przemyślany i ergonomiczny układ, dbałość o detale, wygoda i funkcjonalność. Budujemy na lata i chcemy, aby nasze domy były kojarzone z bezpieczeństwem, jakością i trwałością.\n' +
      'Standard, który stosujemy w budowie każdego osiedla to: dogłębna analiza przed wykonawcza i szczegółowa dokumentacja techniczna, dobór optymalnych rozwiązań do każdej budowy, sprawdzony fachowy zespół oraz produkty najwyższej jakości.\n' +
      'Nasza kadra to kompetentny zespół inżynierów, brygady wykonawcze dzięki którym, jesteśmy w stanie podjąć się każdego wyzwania, nawet tego najbardziej skomplikowanego, realizując je w terminie i na najwyższym poziomie.\n' +
      'Stawiamy na jakość, terminowość, rzetelność oraz optymalizacje kosztów. Zadowolony klient jest dla nas najważniejszy.\n' +
      'Zapraszamy do współpracy!\n',
    logoUrl: JAGODOWE_LOVE_LOGO,
    clientUrl: 'https://jagodowelove.pl/',
    p2: true,
    apartmentData: [
      {
        streetName: 'Jagodowe Love',
        number: '10A',
        sqm: 'b.d. ',
        floorPlanUrl: JAGODOWE_LOVE_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/jagodowe-love/10a.3d',
      },
      {
        streetName: 'Jagodowe Love',
        number: '10B',
        sqm: 'b.d. ',
        floorPlanUrl: JAGODOWE_LOVE_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/jagodowe-love/10b.3d',
      },
      {
        streetName: 'Jagodowe Love',
        number: '1A',
        sqm: 'b.d. ',
        floorPlanUrl: JAGODOWE_LOVE_FLOORPLAN3,
        tourUrl: 'https://tours.3destate.pl/jagodowe-love/1a.3d',
      },
    ]
  },
  {
    id: 17,
    title: 'Fabryka Domów SPOMET',
    description: 'Fabryka Domów SPOMET S.A. na rynku budownictwa działa od 2008 r. Specjalizuje się w branży budownictwa prefabrykowanego. Oferujemy całoroczne, solidne oraz energooszczędne domy jednorodzinne, usługowe jak również domy szeregowe o krótkim cyklu budowy. Wybudowaliśmy setki domów dla prywatnych inwestorów na terenie całej Europy, jak również prowadzimy inwestycje deweloperskie na terenie Polski południowej.\n' +
      'Najnowszą gałęzią Spółki są ekskluzywne wille Lux SPA posiadające prywatną strefę relaksu z basenem, jacuzzi i sauną. \n',
    logoUrl: SPOMET_LOGO,
    clientUrl: 'https://www.domymax.pl/',
    p2: true,
    apartmentData: [
      {
        streetName: 'Dom jednorodzinny',
        number: 'Dom jednorodzinny',
        sqm: '247,31 ',
        floorPlanUrl: SPOMET_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/dom-jednorodzinny/domjednorodzinny.3d',
      },
    ]
  },
  {
    id: 18,
    title: 'Fabryka Domów Spomet',
    description: 'GEPHOUSE – Nowoczesny deweloper\n' +
      'Jako deweloper budujemy domy jedno- i wielorodzinne, całe kompleksy lub miniosiedla.\n' +
      'Zrealizowaliśmy wiele inwestycji budowlanych i mamy duże grono zadowolonych ze\n' +
      'współpracy klientów\n' +
      'Od lat stawiamy sobie za główny cel zadowolenie klientów. Uzyskujemy je poprzez magiczną\n' +
      'mieszankę wysokiej klasy budownictwa w ciekawych lokalizacjach, z rozsądnym podejściem\n' +
      'sprzedażowym i poziomem cen, który usatysfakcjonuje wielu potencjalnych mieszkańców.',
    logoUrl: GEP_LOGO,
    clientUrl: 'https://gephouse.pl/',
    p2: true,
    apartmentData: [
      {
        streetName: 'Nowy Dopiewiec',
        number: 'Nowy Dopiewiec',
        sqm: '98',
        floorPlanUrl: GEP_FLOORPLAN1,
        tourUrl: 'https://tours.3destate.pl/nowy-dopiewiec/dopowiec.3d',
      },
      {
        streetName: 'Radzyny',
        number: 'Radzyny',
        sqm: '80',
        floorPlanUrl: GEP_FLOORPLAN2,
        tourUrl: 'https://tours.3destate.pl/radzyny/radzyny.3d',
      },
    ]
  },
]
